import React from "react";
import { ChatWindow } from "../../Components";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { hasPermission } from "../../Components/Constants/AppConstant";

export default function Chat({
  setAuth,
  setModal,
  NotifModul,
  user,
  profiles,
  setModalNotification,
  closeCartPanel,
  cartItem,
  goToPricing,
  setOfferSelectedForReview,
  chatInfo,
  onStartChat,
}) {


  return (
    <>
      {hasPermission(12) ? (
        <>
          <div className="main">
            {/* <div className="main__inner"> */}
            <div className="billing dashboard">
              <ChatWindow
                chatInfo={chatInfo}
                onStartChat={onStartChat}
                user={user}
              />
            </div>
            {/* </div> */}
          </div>
        </>
      ) : (
        <NotSubscribe
          goToPricing={goToPricing}
          type="brand"
          setAuth={setAuth}
          setModal={setModal}
          NotifModul={NotifModul}
          setNotifModul={setModalNotification}
          profiles={profiles}
          closeCartPanel={closeCartPanel}
          user={user}
          cartItem={cartItem}
          title={"Messages"}
          background={"background_offers.png"}
        />
      )}
    </>
  );
}
